import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import { Toaster } from 'react-hot-toast';
import DownloadPage from './pages/DownloadPage';
import PlaylistPage from './pages/PlaylistPage';
import HistoryPage from './pages/HistoryPage';
import SettingsPage from './pages/SettingsPage';
import Layout from './components/Layout/Layout';
import { DownloadProvider, useDownload } from './contexts/DownloadContext';

const theme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#FF3B30',
    },
    secondary: {
      main: '#5856D6',
    },
    background: {
      default: '#0A0A0A',
      paper: '#1A1A1A',
    },
    text: {
      primary: '#FFFFFF',
      secondary: '#8E8E93',
    },
    success: {
      main: '#34C759',
    },
    warning: {
      main: '#FF9500',
    },
    error: {
      main: '#FF3B30',
    },
    info: {
      main: '#007AFF',
    },
  },
  typography: {
    fontFamily: '"Inter", "Helvetica", "Arial", sans-serif',
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 600,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 12,
          border: '1px solid #2A2A2A',
        },
      },
    },
  },
});

// Platform loader component
const PlatformLoader = () => {
  const { fetchSupportedPlatforms } = useDownload();
  
  useEffect(() => {
    fetchSupportedPlatforms();
  }, []);
  
  return null;
};

function App() {
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <DownloadProvider>
        <PlatformLoader />
        <Router>
          <Routes>
            <Route path="/" element={<Layout />}>
              <Route index element={<DownloadPage />} />
              <Route path="playlist" element={<PlaylistPage />} />
              <Route path="history" element={<HistoryPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Router>
      </DownloadProvider>
      <Toaster 
        position="top-right"
        toastOptions={{
          duration: 4000,
          style: {
            background: '#1A1A1A',
            color: '#FFFFFF',
            border: '1px solid #333',
          },
        }}
      />
    </ThemeProvider>
  );
}

export default App;